import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <RankingSection />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <TopicsSection />
        <AppSection />
        <IndexSection />
        <CardsSection />
        <AboutSection />
        <FeaturesSection />
        <CommentsSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}